export default "__VITE_ASSET__xH2ff$RJ__"